import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { colors } from './color';

export const style = {
  fontFamily: '"Segoe UI", Tahoma, Geneva, Verdana, sans-serif',
};

export const useStyles = makeStyles({
  chartContainer: {
    '& .highcharts-tooltip-box': {
      fontSize: tokens.fontSizeBase200,
      lineHeight: tokens.lineHeightBase200,
      backgroundColor: colors.white,
      color: tokens.colorNeutralForeground1,
      filter: `drop-shadow(0 0 ${tokens.spacingVerticalXXS} ${tokens.colorNeutralShadowAmbient})
        drop-shadow(0 ${tokens.spacingVerticalXS} ${tokens.spacingVerticalS} ${tokens.colorNeutralShadowKey})`,
    },
    height: '100%',
    marginTop: tokens.spacingVerticalMNudge,
    fontSize: tokens.fontSizeBase200,
    '& [data-highcharts-chart]': {
      height: '95%',
      '& .highcharts-container': {
        height: '100% !important',
        paddingTop: tokens.spacingVerticalSNudge,
        ...shorthands.overflow('visible !important'),
        '& .highcharts-root': {
          ...shorthands.overflow('visible'),
        },
      },
    },

    '& .highcharts-plot-bands-0': {
      opacity: '35%',
    },
  },
  spinner: {
    marginTop: '70px',
  },
});
